/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/circle-alert
 */
import { default as DefaultIcon } from '~icons/lucide/circle-alert';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const CircleAlertIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
